import { TasticProps } from '../../types';
import { FooterCards, FooterCardsProps } from 'components/gruenland/organisms/footer/FooterCards';

const FooterCardsTastic = ({ data }: TasticProps<FooterCardsProps>) => {
  return <FooterCards cards={data.cards} />;
};
export default FooterCardsTastic;
